
/* eslint-disable */
// @ts-nocheck
import { Toast } from '@/utils/index';
import { defineComponent } from 'vue';
import { UserOutlined, LockFilled } from '@ant-design/icons-vue';
import jigsaw from '@/utils/jigsaw';
import { login } from "@/request/view/repair";
import { initOptionsData } from '@/components/staff/serve';
import store from '@/store/index';
import router from '@/router/index';
import websocket from '@/utils/base/socket';
import MenuManager from '@/utils/base/getMenu';

let that;
export default defineComponent({
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
      showbutton: true,
      rpassword: false,
      automaticlogon: false,
    };
  },
  components: {
    UserOutlined, LockFilled,
  },
  computed: {
    isMobile() {
      return store.state.isMonile;
    },
  },
  methods: {
    rpasswordStatusChange() {
      if (!this.rpassword) this.automaticlogon = false;
    },
    tologin() {
      login({
        username: that.username,
        password: that.password,
      }).then(res => {
        if (res.code === 200) {
          if (that.rpassword) {
            localStorage.setItem('qc_user_account', JSON.stringify({ username: that.username, password: that.password }));
          } else {
            localStorage.removeItem('qc_user_account');
          }
          localStorage.setItem('qc_user_account_status', JSON.stringify({ rpassword: that.rpassword, automaticlogon: that.automaticlogon }));

          localStorage.setItem('replace', 'false');
          localStorage.setItem('qc_userInfo', JSON.stringify(res.data));
          Toast('success', '登录成功', 2);
          that.$store.commit('SET_USER_INFO', res.data);

          const { firstLevelDepartment } = res.data;

          websocket.Init(res.data.id);
          initOptionsData();
          const menuManager = new MenuManager(res.data.id);
          menuManager.findRoute().then((res) => {
            if (store.state.isMonile) {
              that.$router.replace({ path: '/mobileentry' });
            } else {
              that.$router.push({ path: '/home' });
            }
          }).catch(err => {
            console.log(err, '这是什么报错的信息');
          });
        }
        else {
          Toast('error', res.message, 4);
        }
      }).catch((error) => {
        Toast('error', error.message, 4);
      })
    },
    login() {
      if (this.username === '') {
        Toast('warning', '请输入账号', 2);
        return;
      } else if (this.password === '') {
        Toast('warning', '请输入密码', 2);
        return;
      }
      if (process.env.NODE_ENV === 'development') {
        this.tologin();
      } else {
        this.showbutton = false;
        this.$nextTick(() => {
          this.initsplider();
        });
      }
    },
    initsplider() {
      if (!jigsaw) {
        document.write('<script src="../../utils/jigsaw.min.js"><\/script>');
      }
      // 登录的方法
      function tologin() {
        login({
          username: that.username,
          password: that.password,
        }).then(res => {
          if (res.code === 200) {
            Toast('success', '登录成功', 2);
            if (that.rpassword) {
              localStorage.setItem('qc_user_account', JSON.stringify({ username: that.username, password: that.password }));
            } else {
              localStorage.removeItem('qc_user_account');
            }
            localStorage.setItem('qc_user_account_status', JSON.stringify({ rpassword: that.rpassword, automaticlogon: that.automaticlogon }));
            localStorage.setItem('qc_userInfo', JSON.stringify(res.data));
            localStorage.setItem('replace', 'false');
            that.$store.commit('SET_USER_INFO', res.data);
            // router.push({ path: '/repair' });
            const menuManager = new MenuManager(res.data.id);
            const { firstLevelDepartment } = res.data;
            websocket.Init(res.data.id);
            initOptionsData();
            menuManager.findRoute().then((res) => {
              // const path = store.state.isMonile ? '/mobileentry' : '/home';
              // that.$router.push({ path });

              if (store.state.isMonile) {
                that.$router.replace({ path: '/mobileentry' });
              } else {
                that.$router.push({ path: '/home' });
              }
            }).catch(err => {
              console.log(err, '这是什么报错的信息');
            });
          }
          else {
            Toast('error', res.message, 4);
          }
          that.showbutton = !that.showbutton;
          // 重置下登录的图片
          document.getElementsByClassName('jigsaw__refreshIcon--2rYeZ')[0].onclick();
        }).catch((error) => {
          console.log(error);
          that.showbutton = !that.showbutton;
          Toast('error', error.message, 4);
          document.getElementsByClassName('jigsaw__refreshIcon--2rYeZ')[0].onclick();
        })
      }
      function cleanMsg() {
        document.getElementById('msg').innerHTML = '';
      }
      // 初始化滑动的canvas
      window.jigsaw.init({
        el: document.getElementById('captcha'),
        onSuccess() {
          tologin()
        },
        onFail: cleanMsg,
        onRefresh: cleanMsg,
      });
      /* eslint-disable */
    },
  },
  created() {
    that = this;
  },
  mounted() {
    const user_account = JSON.parse(localStorage.getItem('qc_user_account'));
    const user_account_status = JSON.parse(localStorage.getItem('qc_user_account_status'));

    const logout = localStorage.getItem('logout');

    if (user_account) {
      this.username = user_account.username;
      this.password = user_account.password;
    }

    if (user_account_status) {
      this.rpassword = user_account_status.rpassword;
      this.automaticlogon = user_account_status.automaticlogon;
    }

    if (logout === 'true') {
      localStorage.removeItem('logout');
      return;
    }

    if (user_account_status && user_account_status.automaticlogon) {
      this.tologin();
    }

  }
});
